import script from "./TeacherScorePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherScorePage.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherScorePage.vue?vue&type=style&index=0&id=27ab002a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ab002a"]])

export default __exports__